import { updatePreset } from 'common/api/v1/systems';
import showToast from 'common/utils/showToast';

import {
    SAVE_ITEM,
    SAVE_ITEM_FAILURE,
    SAVE_ITEM_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

import closeModal from './closeModal';
import fetchSystems from './fetchSystems';

export default (values) => (dispatch) => {
    const { id, system_id, system_uniqueid, ...configFields } = values;

    const payload = {
        id,
        system_id,
        system_uniqueid,
        preset_configuration: configFields,
    };

    dispatch(actions[SAVE_ITEM]());

    return updatePreset(payload, system_id)
        .then(() => {
            dispatch(actions[SAVE_ITEM_SUCCESS]());
            dispatch(fetchSystems());
            dispatch(closeModal());
            showToast();
        })
        .catch((error) =>
            dispatch(actions[SAVE_ITEM_FAILURE](error?.response?.data?.errors)),
        );
};
